import React from 'react';
import LazyPageLoader from "../../components/LazyPageLoader.tsx";

const Page = React.lazy(()=>import('./PolotnoIndex'));

export default function LazyPolotnoIndex(){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}



